/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import {
  Checkbox,
  FormControlLabel,
  MenuItem,
  Radio,
  TextField,
} from '@material-ui/core';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import { AllManufacturer } from './TableHead';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  radioGroupLabelNamePlan,
  viewPortHeight_355,
} from '../../../../SharedModules/CommonConstants/commonConstants';
import {
  quarterTest1,
  quarterTest2,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  REBATE_PROGRAM_REQUIRED,
  STATUS_MSG,
  SUCCESS_MSG,
  ERRORMESSAGE_MFR_NOT_EMPTY_FOR_UNIT_CONVERSION,
  VALIDATE_QUARTER_VALUE,
  QUARTER_VALUE_REQUIRED,
  NO_DATA,
} from '../../../../SharedModules/Errors/constantMessageData';
import {
  dispatchErrorMsgMfgOutStandingBalance,
  getRebateProgrameList,
  getPlanTypeValues,
  getManufacturerList,
  setSearchResult,
  setManufacturerOutstandingBalHeader,
  getManufacturerOutstandingBalHeader,
  setManufacturerOutstandingBalReport,
  getManufacturerOutstandingBalReport,
  dispatchMfgListOfMfgOut,
} from '../Store/Actions';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';

import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import {
  autoFormateDate,
  quarterToDate,
  tabHighLigther,
} from '../../../../SharedModules/utilities/utilities';
import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';

const ReqManufacturerOutstandingBal = (props) => {
  const dispatch = useDispatch();

  const {
    planType: planTypeList,
    rebateProgram: getRebateProgramList,
    rebateProgramName: getRebateProgramName,
    selectedPlanType,
    performDisputeResolutionObj: requestCurrentDisData,
    manufacturerList: resultanufacturerList,
    generateInvoiceTabObj: searchScreenTabData,
    isLoading,
    errorMessages: getErrorMsg,
    allRebateProgram: allRebateProgramValue,
    isAllManufacturersSelected: isAllManufacturersSelectedValue,
    selectRowIndex: selectRowIndexValue,
    headerSearchResult,
    searchResult,
    quarterValue,
    mfgListSelected,
  } = useSelector(
    (state) => state?.sharedState?.ManufacturerOutstandingBalanceReducer
  );
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );

  // initial constants
  const gridApiRef = useRef(null);
  const [rebateProgramList, setRebateProgramList] = React.useState([]);
  const [radioList, setRadioList] = React.useState([]);
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [allRebateProgram, setAllRebateProgram] = React.useState(
    allRebateProgramValue
  );
  const [manufacturerList, setManufacturerList] = React.useState([]);
  const [isAllManufacturersSelected, setIsAllManufacturersSelected] =
    React.useState(isAllManufacturersSelectedValue);
  const [scrollDownManufacturers, setScrollDownManufacturers] =
    React.useState(true);
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [manufacturerSelected, setManufacturerSelected] = React.useState('ALL');
  const [headerSearchResultList, setHeaderSearchResultList] = React.useState(
    []
  );
  const [isSearchClicked, setSearchClicked] = React.useState(false);

  // React.useEffect(() => {
  //   if (isSearchClicked && searchResult.length > 0) {
  //     setSearchClicked(false);
  //     const updateTabs =
  //       JSON.parse(localStorage.getItem('tabItemsData')) === null
  //         ? []
  //         : JSON.parse(localStorage.getItem('tabItemsData'));
  //     updateTabs.push({
  //       navTo: '/displayManufacturerOutstandingBalance',
  //       value: 'Display Manufacturer Outstanding Balance',
  //     });
  //     localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
  //     props.history.push({
  //       pathname: '/displayManufacturerOutstandingBalance',
  //     });
  //     dispatch(
  //       clearReduxForFilterAndSort('/displayManufacturerOutstandingBalance')
  //     );
  //   }
  // }, [searchResult]);

  // states with initial values
  const [state, setState] = React.useState(
    requestCurrentDisData?.state
      ? requestCurrentDisData?.state
      : {
          planTypeCd: userDefaults?.planTypeCd
            ? selectedPlanType || userDefaults?.planTypeCd
            : 'FD',
          rebateProgramCd: userDefaults?.rebateProgramCd
            ? getRebateProgramName?.rebateProgramCd ||
              userDefaults?.rebateProgramCd
            : '-1',
          quarterValue: quarterValue,
          isAllManufacturersSelected: true,
          allRebateProgram: false,
        }
  );

  //  tab highliter Functionality
  React.useEffect(() => {
    if (getErrorMsg && getErrorMsg.length > 0) {
      tabHighLigther('/manufacturerOutstandingBalance', true);
    } else {
      tabHighLigther('/manufacturerOutstandingBalance', false);
    }
  }, [JSON.stringify(getErrorMsg)]);

  // on scroll default top level
  const handleScrollToEvent = () => {
    window.scrollTo(0, 0);
  };
  // Plan type useEffect
  React.useEffect(() => {
    handleScrollToEvent();
    if (!planTypeList?.PLAN_TYPE_CD) {
      dispatch(getPlanTypeValues({}));
    }
  }, []);

  // setting radioList from planList Api
  React.useEffect(() => {
    if (
      planTypeList &&
      planTypeList.PLAN_TYPE_CD &&
      planTypeList.PLAN_TYPE_CD.length > 0
    ) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          disabled: allRebateProgram,
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
    }
  }, [planTypeList]);

  // set Rebate Program List
  const rebatepgmDropdown = async (planType) => {
    const getRebateProgramList = await dispatch(
      getRebateProgrameList(state.planTypeCd)
    );
    let list = [];
    if (
      getRebateProgramList?.status === STATUS_MSG &&
      getRebateProgramList?.message === SUCCESS_MSG
    ) {
      if (!_.isEmpty(getRebateProgramList.data)) {
        list = _.map(getRebateProgramList.data, (val) => ({
          ...val,
          id: val.rebateProgramCd,
          name: `${val.rebateProgramCd} | ${val.shortDescr}`,
        }));
      }
    }
    setRebateProgramList(
      list.sort((key, val) =>
        key.name.toLowerCase().localeCompare(val.name.toLowerCase())
      )
    );
  };

  // get rebate program
  React.useEffect(() => {
    rebatepgmDropdown(state.planTypeCd);
  }, [state.planTypeCd]);

  // on change event on filed
  const handleOnChangeEvent = (value, name) => {
    let localErr = getErrorMsg || [];
    if (name === 'planTypeCd') {
      dispatch(dispatchErrorMsgMfgOutStandingBalance([]));
      setState({ ...state, [name]: value, rebateProgramCd: '-1' });
      if (value === 'ST' || value === 'FD') {
        dispatch(
          getManufacturerList({
            planType: 'st',
            asMode: 1,
          })
        );
      }
      if (value === 'SUPP' || value === 'COMM') {
        dispatch(
          getManufacturerList({
            planType: 'supp',
            asMode: 1,
          })
        );
      }
      return;
    }
    if (name === 'rebateProgramCd') {
      setState({ ...state, [name]: value });
    }
    if (name === 'quarterValue') {
      setState({ ...state, [name]: value });
    }
    localErr = localErr.filter((item) => item.field !== 'nodata');
    dispatch(dispatchErrorMsgMfgOutStandingBalance(localErr));
  };

  // on blur functionality on field level
  const handleOnblurEvent = (type, value) => {
    let localErr = getErrorMsg || [];
    const data = value;
    if (type === 'rebateProgramCd') {
      localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
    }

    if (type === 'quarterValue') {
      if (data && !_.isEmpty(data)) {
        const indexOf = !_.isEmpty(localErr)
          ? _.findIndex(localErr, {
              field: 'quarter',
              errorType: 'required',
            })
          : null;

        if (!_.isNull(indexOf) && indexOf >= 0) {
          localErr.splice(indexOf, 1);
        }
        if (quarterTest1.test(data) || quarterTest2.test(data)) {
          const indexOf = !_.isEmpty(localErr)
            ? _.findIndex(localErr, {
                field: 'quarter',
                errorType: 'invalidFormat',
              })
            : null;

          if (!_.isNull(indexOf) && indexOf >= 0) {
            localErr.splice(indexOf, 1);
          }
          localErr = localErr.filter((item) => item.field !== 'quarter');
          setState({
            ...state,
            quarterValue: autoFormateDate(value?.toUpperCase()),
          });
        } else {
          localErr = localErr.filter((item) => item.field !== 'quarter');
          localErr.push({
            field: 'quarter',
            errorType: 'invalidFormat',
            message: VALIDATE_QUARTER_VALUE,
          });
        }
      } else {
        localErr = localErr.filter((item) => item.field !== 'quarter');
        localErr.push({
          field: 'quarter',
          errorType: 'required',
          message: QUARTER_VALUE_REQUIRED,
        });
      }
    }

    if (type === 'manufacturer') {
      if (manufacturerSelected?.length === 0) {
        localErr = localErr.filter(
          (item) => item.field !== 'manufacturerSelect'
        );
        localErr.push({
          field: 'manufacturerSelect',
          errorType: 'manuRequired',
          message: ERRORMESSAGE_MFR_NOT_EMPTY_FOR_UNIT_CONVERSION,
        });
      } else {
        localErr = localErr.filter(
          (item) => item.field !== 'manufacturerSelect'
        );
      }
    }
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgMfgOutStandingBalance(unique));
  };

  // To get manufacturer List
  React.useEffect(() => {
    dispatch(
      getManufacturerList({
        planType: 'fd',
        asMode: 1,
      })
    );
  }, []);

  // Manufacturer Grid From API
  React.useEffect(() => {
    setManufacturerList(resultanufacturerList?.rebatePercentOfSpendMfgGridVO);
  }, [resultanufacturerList]);

  // to get all Rebate Program
  // React.useEffect(() => {
  //   dispatch(
  //     getManufacturerOutstandingBalHeader({
  //       qtr: state.quarterValue,
  //       mfgId:
  //         manufacturerSelected == 'ALL'
  //           ? [manufacturerSelected]
  //           : manufacturerSelected,
  //       aiAll: manufacturerSelected == 'ALL' ? 1 : 0,
  //       // aiAll: manufacturerSelected ? 1 : 0,
  //       rebateProgramCd: allRebateProgram ? 'ALL' : state.rebateProgramCd,
  //     })
  //   );
  // }, [allRebateProgram, state.quarterValue]);

  // From API
  React.useEffect(() => {
    setHeaderSearchResultList(headerSearchResult);
  }, [headerSearchResult]);

  // fullscreen functionality
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };

  // On selection of the row data
  const onSelectionChanged = (e) => {
    const selectedRows = e.api?.getSelectedRows();

    const selectedNodes = e.api.getSelectedNodes();
    const lastSelectedNode = selectedNodes[selectedNodes.length - 1];
    const lastSelectedDisplayIndex = lastSelectedNode?.rowIndex ?? 0
      if (selectedNodes.length > 0) {
        const firstCol = e.columnApi.getAllDisplayedColumns()[0];
        e.api.setFocusedCell(lastSelectedDisplayIndex, firstCol);
      } else {
        e.api.clearFocusedCell();
      }

    setSelectedRows(selectedRows);
    dispatch(dispatchMfgListOfMfgOut(selectedRows));
    if (
      selectedRows?.length === manufacturerList.length
      // || selectedRows.length === 0
    ) {
      setManufacturerSelected('ALL');
    } else {
      const selectedManuId = [];
      for (let i = 0; i < selectedRows?.length; i++) {
        selectedManuId.push(selectedRows[i].mfgId);
      }
      selectedManuId.sort();
      setManufacturerSelected(selectedManuId);
      let localErr = getErrorMsg || [];
      localErr = localErr.filter((item) => item.field !== 'manufacturerSelect');
      const unique = [...new Set(localErr)];
      dispatch(dispatchErrorMsgMfgOutStandingBalance(unique));
    }
  };
  const getSelectedRowData = () => {
    const selectedData = gridApiRef.current?.getSelectedRows
      ? gridApiRef.current.getSelectedRows()
      : [];
    return selectedData;
  };

  // On search button functionality
  const onClickSearch = () => {
    let localErr = getErrorMsg || [];
    if (getErrorMsg.length > 0) {
    } else if (
      state.rebateProgramCd === '-1' &&
      // quarterTest1.test(quarterValue) &&
      // isAllManufacturersSelected === false &&
      allRebateProgram === false
    ) {
      localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
      localErr.push({
        field: 'rebateProgramCd',
        errorType: 'rebateRequired',
        message: REBATE_PROGRAM_REQUIRED,
      });
    } else {
      localErr = localErr?.filter((item) => item.field !== 'rebateProgramCd');
    }
    if (manufacturerSelected?.length === 0) {
      localErr = localErr.filter((item) => item.field !== 'manufacturerSelect');
      localErr.push({
        field: 'manufacturerSelect',
        errorType: 'manuRequired',
        message: ERRORMESSAGE_MFR_NOT_EMPTY_FOR_UNIT_CONVERSION,
      });
    } else {
      localErr = localErr.filter((item) => item.field !== 'manufacturerSelect');
    }
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgMfgOutStandingBalance(unique));

    if (unique.length === 0) {
      navigateToDisplay();
    }
  };

  const navigateToDisplay = async () => {
    const rebateProgramName = rebateProgramList.find(
      (item) => item.id == state.rebateProgramCd
    );

    let index = manufacturerList.findIndex(
      (obj) => obj.mfgId === selectedRows[0]?.mfgId
    );
    index = index === -1 ? 0 : index;
    let res = await dispatch(
      getManufacturerOutstandingBalHeader({
        qtr: state.quarterValue,
        mfgId:
          manufacturerSelected == 'ALL'
            ? [manufacturerSelected]
            : manufacturerSelected,
        aiAll: manufacturerSelected == 'ALL' ? 1 : 0,
        // aiAll: manufacturerSelected ? 1 : 0,
        rebateProgramCd: allRebateProgram ? 'ALL' : state.rebateProgramCd,
      })
    );
    if (res?.length) {
      // setSearchClicked(true);

      dispatch(
        setSearchResult({
          rebateProgramName,
          selectedPlanType: state.planTypeCd,
          allRebateProgram,
          manufacturerSelected,
          isAllManufacturersSelected,
          selectRowIndex: index,
          quarterValue: state.quarterValue,
          displayObj: {
            rebateProgramName,
            allRebateProgram,
            quarterValue: state.quarterValue,
            manufacturerSelected,
            headerSearchResult,
          },
        })
      );

      const updateTabs =
        JSON.parse(localStorage.getItem('tabItemsData')) === null
          ? []
          : JSON.parse(localStorage.getItem('tabItemsData'));
      updateTabs.push({
        navTo: '/displayManufacturerOutstandingBalance',
        value: 'Display Manufacturer Outstanding Balance',
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
      props.history.push({
        pathname: '/displayManufacturerOutstandingBalance',
      });
      dispatch(
        clearReduxForFilterAndSort('/displayManufacturerOutstandingBalance')
      );
    } else {
      dispatch(
        dispatchErrorMsgMfgOutStandingBalance([
          { field: 'nodata', message: NO_DATA },
        ])
      );
    }
    // dispatch(
    //   getManufacturerOutstandingBalReport({
    //     qtr: state.quarterValue,
    //     mfgId:
    //       manufacturerSelected == 'ALL'
    //         ? [manufacturerSelected]
    //         : manufacturerSelected,
    //     aiAll: manufacturerSelected == 'ALL' ? 1 : 0,
    //     rebateProgramCd: allRebateProgram ? 'ALL' : state.rebateProgramCd,
    //   })
    // );
  };
  // handing by default multiple row selection function
  const onGridReady = (params) => {
    if (params?.api) {
      gridApiRef.current = params.api;
    }
    if (mfgListSelected?.length > 0 && params?.api) {
      params.api.forEachNode((node) =>
        -1 !==
        mfgListSelected?.findIndex((x) => {
          return x?.mfgId == node.data?.mfgId;
        }) && node.setSelected(true)
      );
    }
  };
  const onFirstDataRendered = (params) => {
    if (params?.api) {
      gridApiRef.current = params.api;
    }

    if (mfgListSelected?.length > 0 && params?.api) {
      params.api.forEachNode((node) =>
        -1 !==
        mfgListSelected?.findIndex((x) => {
          return x?.mfgId == node.data?.mfgId;
        }) && node.setSelected(true)
      );
    }
  };
  // For No Data validation for auto Scroll
  React.useEffect(() => {
    // setErrorList(errors);
    if (isSearchClicked && getErrorMsg?.length > 0) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [getErrorMsg]);
      
  //remove no data error msg
  React.useEffect(() => {
    dispatch(setSearchResult({ errorMessages: [] }));
  }, [state.planTypeCd, planTypeList, allRebateProgram, state.quarterValue, isAllManufacturersSelected, scrollDownManufacturers, fullScreenView, selectRowIndexValue]);

  const cellClickedListener = (e) => {
    if (selectedRows.length > 0) {
      onClickSearch();
    }
  };
  return (
    <div className="tabs-container">
      <Spinner load={isLoading} />
      {!fullScreenView && (
        <>
          <CustomSeparator
            parent1="State Reports"
            parent2="Manufacturer Outstanding Balance"
          />
          <DisplayErrorMessages
            errorMessages={[
              ...new Set(
                getErrorMsg.length > 0
                  ? _.map(getErrorMsg, (l) => l.message)
                  : []
              ),
            ]}
          />
        </>
      )}

      {!fullScreenView && (
        <div className="tab-body custom-search-dates">
          <div className="row">
            <div className="col-4 frr-two-col-radio">
              <RadioGroupComponent
                disabled
                data-testid="req-manuf-bal-fltr"
                id="filter-plan-by-radio-btn-action"
                labelName={radioGroupLabelNamePlan}
                required={false}
                optionList={radioList || []}
                defaultValue={state && state.planTypeCd}
                filterAction={(e) => {
                  handleOnChangeEvent(e, 'planTypeCd');
                }}
                className="log-batch-filter-radio frr-checkInvoiceRadio"
              />
            </div>
            <div className="col-4">
              <fieldset className="custom-fieldset">
                <legend className="same-font-family">Rebate Program</legend>
                <div className="form-wrapper p-0">
                  <div
                    className="mui-custom-form with-select field-xl no-lbl"
                    style={{ marginBottom: '30px' }}
                  >
                    <TextField
                      name="rebateProgram"
                      id="rebateProgram"
                      label="Rebate Program"
                      data-testid="req-manuf-bal-rbt"
                      disabled={allRebateProgram}
                      fullWidth
                      select
                      required
                      inputProps={{ maxLength: 11, id: 'rebateProgram' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      className={
                        getErrorMsg?.length > 0
                          ? _.map(getErrorMsg, (l) =>
                              l.field === 'rebateProgramCd'
                                ? 'mandate-fields frr-display-hidden-label'
                                : 'frr-display-hidden-label'
                            )
                          : 'frr-display-hidden-label'
                      }
                      onBlur={(e) =>
                        handleOnblurEvent('rebateProgramCd', e.target.value)
                      }
                      onChange={(e) =>
                        handleOnChangeEvent(e.target.value, 'rebateProgramCd')
                      }
                      value={
                        state && state.rebateProgramCd
                          ? state.rebateProgramCd
                          : ''
                      }
                      error={
                        getErrorMsg?.length > 0
                          ? _.map(getErrorMsg, (l) =>
                              l.field === 'rebateProgramCd' ? l.message : null
                            )
                          : null
                      }
                      helperText={
                        getErrorMsg?.length > 0
                          ? _.map(getErrorMsg, (l) =>
                              l.field === 'rebateProgramCd' ? l.message : null
                            )
                          : null
                      }
                    >
                      <MenuItem
                        key=""
                        value="-1"
                        className="frr-dropdown-blank-item"
                      />
                      {rebateProgramList &&
                      rebateProgramList.length &&
                      rebateProgramList.length > 0
                        ? rebateProgramList.map((item) => {
                            return (
                              <MenuItem key={item.id} value={item.id}>
                                {item.name}
                              </MenuItem>
                            );
                          })
                        : null}
                    </TextField>
                  </div>
                </div>
              </fieldset>
            </div>
            <div className="col-4">
              <fieldset className="custom-fieldset">
                <legend className="same-font-family">Quarter</legend>
                <div className="form-wrapper p-0">
                  <div
                    className="mui-custom-form with-select field-xl no-lbl"
                    style={{ marginBottom: '30px' }}
                  >
                    <TextField
                      id="check_by_invoice_quater"
                      data-testid="req-manuf-bal-inv"
                      label="quarter"
                      required
                      fullWidth
                      placeholder=""
                      inputProps={{
                        maxLength: 6,
                        id: 'check_by_invoice_quater',
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={state.quarterValue}
                      onChange={(e) => {
                        handleOnChangeEvent(e.target.value, 'quarterValue');
                      }}
                      className={
                        getErrorMsg?.length > 0
                          ? _.map(getErrorMsg, (l) =>
                              l.field == 'quarter'
                                ? 'mandate-fields frr-display-hidden-label'
                                : 'frr-display-hidden-label'
                            )
                          : 'frr-display-hidden-label'
                      }
                      onBlur={(e) =>
                        handleOnblurEvent('quarterValue', e.target.value)
                      }
                      helperText={
                        getErrorMsg?.length > 0
                          ? _.map(getErrorMsg, (l) =>
                              l.field === 'quarter' ? l.message : null
                            )
                          : null
                      }
                      error={
                        getErrorMsg?.length > 0
                          ? _.map(getErrorMsg, (l) =>
                              l.field == 'quarter' ? l.message : null
                            )
                          : null
                      }
                    />
                  </div>
                </div>
              </fieldset>
            </div>
          </div>

          <div className="row ml-3 ">
            <div className="col-4 mt-3 ">
              <FormControlLabel
                // style={{ marginTop: '25px' }}
                control={
                  <Checkbox
                    color="primary"
                    checked={allRebateProgram}
                    name="allRebateProgram"
                    onBlur={() => {}}
                    onChange={() => {
                      setAllRebateProgram(!allRebateProgram);
                      const tempRadioList = radioList.map((item) => {
                        return { ...item, disabled: !allRebateProgram };
                      });
                      setRadioList(tempRadioList);
                      let localErr = getErrorMsg || [];
                      localErr = localErr.filter(
                        (item) =>
                          item.field !== 'rebateProgramCd' ||
                          item.field !== 'nodata'
                      );
                      const unique = [...new Set(localErr)];
                      dispatch(dispatchErrorMsgMfgOutStandingBalance(unique));
                    }}
                  />
                }
                label="All Rebate Programs"
              />
            </div>
            <div className="col-4 mt-3">
              <FormControlLabel
                // style={{ marginTop: '25px' }}
                control={
                  <Checkbox
                    // defaultChecked
                    checked={isAllManufacturersSelected}
                    color="primary"
                    name="allManufacturers"
                    onBlur={(e) => {
                      handleOnblurEvent('manufacturer', e?.target.value);
                    }}
                    onChange={async (e) => {
                      setIsAllManufacturersSelected(
                        !isAllManufacturersSelected
                      );
                      setScrollDownManufacturers(!scrollDownManufacturers);
                      if (!isAllManufacturersSelected) {
                        setManufacturerSelected('ALL');
                        dispatch(dispatchMfgListOfMfgOut([]));
                      } else {
                        setManufacturerSelected([]);
                      }
                      let localErr = getErrorMsg || [];
                      localErr = localErr.filter(
                        (item) => item.field !== 'nodata'
                      );
                      const unique = [...new Set(localErr)];
                      dispatch(dispatchErrorMsgMfgOutStandingBalance(unique));
                      const elem = document.getElementById('abc11');
                      if (elem && scrollDownManufacturers) {
                        await Promise.resolve();
                        // setTimeout(() => {
                          elem.scrollIntoView();
                        // }, 1000);
                      }
                    }}
                  />
                }
                label="All Manufacturers"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-12 btn-wrapper mb-2">
              <div className="float-right mt-2 hide-on-print">
                <Button
                  className="btn btn-success btn-search"
                  data-testid="view_detail_ia"
                  type="button"
                  onClick={onClickSearch}
                >
                  {' '}
                  <SVGComponent iconName="Icon-search" /> Search
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="row" id="abc11">
        {!isAllManufacturersSelected && (
          <div className="col-12 unallocated">
            <TableGrid
              onSelectionChanged={onSelectionChanged}
              gridCall={onGridReady}
              gridDataRendered={onFirstDataRendered}
              getSelectedRowData={getSelectedRowData}
              rowData={manufacturerList || []}
              helpMessage
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={handleFullScreenView}
              gridHeight={fullScreenView ? '100vh' : viewPortHeight_355}
              columnDefs={AllManufacturer}
              cellClickedListener={cellClickedListener}
              selectRowIndex={(Array.isArray(mfgListSelected)&&mfgListSelected.length>0)?
                (mfgListSelected?.[0]?.mfgId) : 0
              }
              rowSelection="multiple"
              rowMultiSelectWithClick
              data-testid="onEditingStopped"
              fileName="Manufacturer List"
              enterMovesDown
              suppressCellFocus
              singleClickEdit
              exportFile
              hideColumnsInPdf
              frameworkComponents={{
                TextBoxRender: (cellInfo) => {
                  const name = cellInfo?.value;

                  if (name && name.length > 30) {
                    return (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                      >
                        <div>{name && `${name.substring(0, 30)}...`}</div>
                      </OverlayTrigger>
                    );
                  }
                  return <div>{name}</div>;
                },
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ReqManufacturerOutstandingBal;
